export default __webpack_public_path__ + "static/media/parokshaba.ced0dc81.png";